export default "__VITE_ASSET__Bp81XhgR__"